import { API_URL, getHeaders } from "../../utils/contextHelpers";
import { api, request } from "./core";


export const crearFicha = (formData) => {
  const headers = getHeaders();
  headers.delete("Content-Type");
  return request(`${API_URL}ficha/crear`, {
    method: "POST",
    headers,
    body: formData,
  });
};

export const modificarFicha = (formData) => {
  const headers = getHeaders();
  headers.delete("Content-Type");
  return request(`${API_URL}ficha/modificar`, {
    method: "POST",
    headers,
    body: formData,
  });
};

export const getAtributosFicha = api("getAtributosFicha", (codigo) => `${API_URL}ficha/atributos?codigo=${encodeURIComponent(codigo)}`);

export const eliminarFicha = api("eliminarFicha", (id) => `${API_URL}ficha/eliminar?id=${encodeURIComponent(id)}`);

export const getFicha = api("getFicha", (codigo) => `${API_URL}ficha/obtener?codigo=${encodeURIComponent(codigo)}`);

export const descargarFicha = async (codigo) => {
  const headers = getHeaders();
  const response = await fetch(
    `${API_URL}ficha/descargar?codigo=${encodeURIComponent(codigo)}`,
    { headers }
  );
  if (!response.ok) {
    let message = "Error al descargar ficha";
    try {
      const data = await response.json();
      if (data?.mensaje) message = data.mensaje;
    } catch {
      /* ignore */
    }
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return response.blob();
};